import {Component, OnInit} from '@angular/core';
import {StepComponent} from '../../step/step.component';
import {StepService} from '../../services/step.service';
import {ActivatedRoute, Router} from '@angular/router';
import {WpcheckRequestService} from '../services/request.service';
import {ElementService} from '../../services/element.service';
import {PortalService} from '../../services/portal.service';

/**
 * Special component for the start page of the chapter "eingabe". Only Textoutputs, no form.
 */
@Component({
    selector: 'app-wpcheck-eingabe-start',
    templateUrl: './eingabe.start.component.html',
    standalone: false
})
export class EingabeStartComponent extends StepComponent implements OnInit {

  /**
   * placeholder for portalname in welcome text
   */
  welcomePlaceholder: any = {};

  /**
   * current portalId
   */
  portalId: string;

  /**
   * link to next step
   */
  nextLink: string = "../../wpcheck/eingabe/basisinformationen/1";

  constructor(protected stepService: StepService, protected router: Router, protected requestService: WpcheckRequestService,
              protected elementService: ElementService, protected portalService: PortalService,
              private route: ActivatedRoute, private activatedRoute: ActivatedRoute) {
    super(stepService, router, elementService);
  }
  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();
    // get the current portalId
    this.portalId = this.portalService.currentPortalId;

    this.activatedRoute.queryParams.subscribe(params => {
      if (params?.step === 'basisdaten2') {
        this.nextStep();
      }
    });

    //init Placeholder
    if(this.portalService.getConfig('embed.portal.welcometext')) {
      this.welcomePlaceholder = {
        portalPlaceholder: ' ' + this.portalService.getConfig('embed.portal.welcometext')
      }
    }
    else {
      this.welcomePlaceholder = {
        portalPlaceholder: ''
      }
    }
  }

  /**
   * move to the next step
   */
  nextStep(): void {
    // forward to second input step
    this.router.navigateByUrl(this.portalService.currentPortalId + '/wpcheck/eingabe/basisinformationen/2');
  }

}
